import React, { useState, useEffect } from "react";
import { api } from "../api";

export default function CampaignView({ campaignId, onClose }) {
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.getCampaign(campaignId).then(setData).catch((err) => alert(err.message));
  }, [campaignId]);

  if (!data) return <div className="modal-backdrop"><div className="modal-content">Loading...</div></div>;

  const records = data.records.filter(r => 
    r.mobile.includes(search) || r.template_type.toLowerCase().includes(search.toLowerCase()) || r.generated_message.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="modal-backdrop">
      <div className="modal-content" style={{ maxWidth: "900px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
          <div>
            <h3>{data.campaign.campaign_name}</h3>
            <span className={`badge badge-${data.campaign.status}`}>{data.campaign.status}</span>
          </div>
          <button className="btn btn-outline" onClick={onClose}>Close</button>
        </div>

        <input 
          type="text" 
          placeholder="Search by Mobile, Template, or Preview content..." 
          className="card" 
          style={{ width: "100%", padding: "0.6rem", marginBottom: "1rem" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="table-container" style={{ maxHeight: "400px", overflowY: "auto" }}>
          <table>
            <thead>
              <tr>
                <th>Mobile</th>
                <th>Type</th>
                <th>VAR1</th>
                <th>VAR2</th>
                <th>VAR3</th>
                <th>Preview</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {records.map((r) => (
                <tr key={r.record_id}>
                  <td>{r.mobile}</td>
                  <td>{r.template_type}</td>
                  <td>{r.var1}</td>
                  <td>{r.var2}</td>
                  <td>{r.var3}</td>
                  <td style={{ maxWidth: "250px", fontSize: "0.75rem", whiteSpace: "pre-wrap" }}>{r.generated_message}</td>
                  <td><span className={`badge badge-${r.status}`}>{r.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}